module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-09-99975b1b5915581c48084290083d3a34.png";